import axiosInstance from "./axiosConfig";
import { handleAPIError } from "./utils/errors";
import type { UserProfile } from "./types";

export type SuperadminLawyerDTO = {
  uid: string;
  firstName: string;
  middleName?: string | null;
  lastName: string;
  email: string;
  practiceName: string;
  disabled?: boolean;
  role?: string | null;
};

export const UsersAPI = {
  async listSuperadmins(): Promise<SuperadminLawyerDTO[]> {
    try {
      const response = await axiosInstance.get("/users/superadmins");
      return response.data;
    } catch (error) {
      const apiError = handleAPIError(error);
      throw apiError;
    }
  },

  /** The profiles the caller may see, keyed by id; others are left out. */
  async getProfiles(userIds: string[]): Promise<Record<string, UserProfile>> {
    try {
      const response = await axiosInstance.post<{
        profiles: Record<string, UserProfile>;
      }>("/users/profiles", { ids: userIds });
      return response.data.profiles ?? {};
    } catch (error) {
      const apiError = handleAPIError(error);
      throw apiError;
    }
  },

  async getProfile(userId: string): Promise<UserProfile> {
    try {
      const response = await axiosInstance.get<UserProfile>(
        `/users/${userId}/profile`
      );
      return response.data;
    } catch (error) {
      const apiError = handleAPIError(error);
      throw apiError;
    }
  }
};
